module.exports = __webpack_public_path__ + "static/media/image-top.fb57f5a6.webp";